import { siteApiSlice } from "../../app/siteApiSlice";

export interface AccountLoginViewModel {
	username: string;
	password: string;
	timezone: string;
}

export const loginApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		login: build.mutation<void, AccountLoginViewModel>({
			query: (payload) => ({
				url: `/Account/Authenticate`,
				method: "POST",
				body: payload,
			}),
			transformErrorResponse: (
				response: { status: string | number; data?: unknown },
				meta,
				arg
			) => {
				const message =
					typeof response.data === "string"
						? response.data
						: "An error occurred while logging in.";
				return message;
			},
		}),
		logout: build.mutation<void, void>({
			query: () => ({
				url: `/Account/Deauthenticate`,
				method: "POST",
			}),
		}),
	}),
});

export const { useLoginMutation, useLogoutMutation } = loginApiSlice;
